<template>
    <div>
        <div v-show="loading" class="small">
            <div class="d-flex align-items-center">
                <div class="spinner-border spinner-border-tiny text-primary mr-2" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
                <div class="text-secondary font-weight-500">{{ loadingText }}</div>
            </div>
        </div>
        <div v-show="!loading" class="small">
            <span class="icon icon-glyphicons-basic-circle-check mr-1 text-success"></span>
            <span class="text-secondary font-weight-500">{{ loadedText }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: "LoadingStatus",
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        loadedText: {
            type: String,
            default: "Saved",
        },
        loadingText: {
            type: String,
            default: "Saving...",
        },
    },
}
</script>

<style>
</style>